import { render } from "./ListaMinnen.vue?vue&type=template&id=af930638&scoped=true"
import script from "./ListaMinnen.vue?vue&type=script&lang=js"
export * from "./ListaMinnen.vue?vue&type=script&lang=js"

import "./ListaMinnen.vue?vue&type=style&index=0&id=af930638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af930638"]])

export default __exports__